export default __webpack_public_path__ + "static/media/blob_green_2.78ad8bfa.svg";